// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Pbxi","actions":"GroupTable_actions__vbhJR","deleteModalFooter":"GroupTable_deleteModalFooter__1BC9K"};